export const FirmCard = {
  extends: 'Link',
  href: (el, s) => '/firm?id=' + s.id,
  textDecoration: 'none',
  color: 'inherit',
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  theme: 'card',
  cursor: 'pointer',
  transition: 'all 0.25s ease',
  ':hover': { boxShadow: 'black.08 0 Z B', transform: 'translateY(-2px)' },

  CardHeader: {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Z',
    FirmLogo: {
      tag: 'img',
      width: 'C1',
      height: 'C1',
      round: 'Z',
      flexShrink: '0',
      src: (el, s) => s.logo || 'https://ui-avatars.com/api/?name=' + encodeURIComponent(s.nameEn) + '&background=1a2332&color=c6ac8f&size=96&bold=true&format=svg'
    },
    NameGroup: {
      flow: 'y',
      gap: 'V',
      minWidth: '0',
      FirmName: { text: (el, s) => s.nameEn, fontSize: 'A', fontWeight: '700', letterSpacing: '-0.01em' },
      FirmNameKa: { text: (el, s) => s.nameKa, fontSize: 'Y', opacity: '0.6' },
      FirmCity: {
        flow: 'x', gap: 'W', align: 'center flex-start',
        CityDot: { text: '\u2022', fontSize: 'Y', opacity: '0.4' },
        CityText: { text: (el, s) => s.city, fontSize: 'Y', opacity: '0.5' },
        YearDot: { text: '\u2022', fontSize: 'Y', opacity: '0.4' },
        YearText: { text: (el, s) => s.foundedYear ? 'Est. ' + s.foundedYear : '', fontSize: 'Y', opacity: '0.5' }
      }
    }
  },

  CardMeta: {
    flow: 'x',
    gap: 'Y',
    align: 'center flex-start',
    marginTop: 'Y',
    opacity: '0.6',
    fontSize: 'Y',
    MetaLawyers: { text: (el, s) => (s.lawyerCount || 0) + ' lawyers' },
    MetaDot: { text: '\u00B7' },
    MetaPhone: { text: (el, s) => s.phone }
  },

  CardAreas: {
    flow: 'x',
    gap: 'W',
    flexWrap: 'wrap',
    marginTop: 'Y',
    children: (el, s) => (s.practiceAreas || []).slice(0, 4).map(a => ({ label: a })),
    childrenAs: 'state',
    childProps: {
      text: (el, s) => s.label,
      fontSize: 'Y',
      padding: 'V Y',
      round: 'C',
      theme: 'secondary',
      fontWeight: '500'
    }
  }
}
